


// type FormQuestionDependency = {
//   questionId: number;
//   parentQuestionId: number;
//   contentId: number[];
//   isRequired?: boolean;
//   /**
//    * فقط زمانی مقدار دارد که سوال والد از نوع «درجه‌بندی» (ستاره‌ای) باشد:
//    * حداقل تعداد ستاره‌ای که باید انتخاب شود تا این سوال (فرزند) نمایش داده شود.
//    */
//   selectedPoint?: number;
// };

// /**
//  * نکته‌ی مهم درباره‌ی contentIdList:
//  * این فیلد روی خودِ سوال (به‌عنوان والد) قرار می‌گیرد و نشان می‌دهد
//  * کدام گزینه‌های پاسخ خودِ همین سوال باعث نمایش فرزندش/فرزندانش می‌شود.
//  *
//  * - اگر سوال هیچ فرزندی نداشته باشد (برگ درخت): contentIdList = null
//  * - اگر فرزند داشته باشد: contentIdList = اجتماع مقادیر محرک (contentId یا
//  *   selectedPoint) که روی خودِ فرزندان ثبت شده‌اند (چون آن مقادیر در واقع
//  *   به گزینه‌های همین سوال، به‌عنوان والد، اشاره می‌کنند)
//  *
//  * این فیلد مستقل از ریشه بودن یا نبودن سوال است؛ حتی سوالات ریشه هم اگر
//  * فرزند داشته باشند، contentIdList غیر-null دارند.
//  */
// type TreeQuestionItem = {
//   questionId: number;
//   contentIdList: number[] | null;
//   priority: number;
//   isMandatory?: boolean;
//   childList: TreeQuestionItem[];
// };

// export function generateQuestionLists(
//   selectQuestionList: FormQuestionDependency[],
//   questions: any[]
// ): TreeQuestionItem[] {
//   const formSelectedQuestions = selectQuestionList || [];

//   /**
//    * priority بر اساس ترتیب واقعی انتخاب/چیدمان کاربر در selectQuestionList
//    */
//   const priorityMap = new Map<number, number>();

//   formSelectedQuestions.forEach((item, index) => {
//     priorityMap.set(Number(item.questionId), index + 1);
//   });

//   /**
//    * وضعیت هر سوال از Formik.
//    *
//    * نکته: از Map استفاده می‌کنیم نه Object، چون کلیدهای عددی روی یک Object
//    * معمولی به‌صورت خودکار صعودی مرتب می‌شوند (صرف‌نظر از ترتیب واقعی درگ‌شده
//    * توسط کاربر) و باعث می‌شود ترتیب خروجی نهایی با priority هماهنگ نباشد.
//    */
//   const stateMap = new Map<number, FormQuestionDependency>();

//   formSelectedQuestions.forEach((item) => {
//     stateMap.set(Number(item.questionId), {
//       questionId: Number(item.questionId),
//       parentQuestionId: Number(item.parentQuestionId ?? 0),
//       contentId: Array.isArray(item.contentId)
//         ? item.contentId.map(Number).filter(Boolean)
//         : [],
//       isRequired: Boolean(item.isRequired),
//       selectedPoint:
//         typeof item.selectedPoint === "number" ? item.selectedPoint : 0,
//     });
//   });

//   /**
//    * parentQuestionId => children (به همان ترتیبی که در formSelectedQuestions آمده‌اند)
//    */
//   const childrenByParent = new Map<number, FormQuestionDependency[]>();

//   formSelectedQuestions.forEach((item) => {
//     const parentId = Number(item.parentQuestionId ?? 0);

//     if (parentId) {
//       const state = stateMap.get(Number(item.questionId))!;

//       if (!childrenByParent.has(parentId)) {
//         childrenByParent.set(parentId, []);
//       }

//       childrenByParent.get(parentId)!.push(state);
//     }
//   });

//   /**
//    * سوال‌هایی که child هستند (یعنی وابسته به یک سوال والد انتخاب‌شده‌اند)
//    */
//   const childQuestionIds = new Set<number>();

//   formSelectedQuestions.forEach((item) => {
//     if (Number(item.parentQuestionId)) {
//       childQuestionIds.add(Number(item.questionId));
//     }
//   });

//   /**
//    * مقادیر محرکی که خودِ یک فرزند (بر اساس نوع پاسخِ والدش) ثبت کرده:
//    * - تک/چند انتخابی و بله‌خیر: همان contentId انتخاب‌شده (گزینه‌هایی از والد)
//    * - درجه‌بندی (ستاره‌ای): مقدار selectedPoint در قالب آرایه‌ی تک‌عضوی
//    * - فایل/متنی: آرایه‌ی خالی (یعنی هر پاسخی محرک است)
//    *
//    * این مقادیر در واقع به گزینه‌های خودِ سوال والد اشاره دارند، برای همین
//    * در نهایت روی نودِ والد (نه فرزند) قرار می‌گیرند.
//    */
//   const resolveTriggerIds = (child: FormQuestionDependency): number[] => {
//     if (typeof child.selectedPoint === "number" && child.selectedPoint > 0) {
//       return [child.selectedPoint];
//     }

//     return Array.isArray(child.contentId) ? child.contentId : [];
//   };

//   /**
//    * ساخت نود درختی.
//    */
//   const buildNode = (
//     questionId: number,
//     visited: Set<number> = new Set()
//   ): TreeQuestionItem | null => {
//     questionId = Number(questionId);

//     if (visited.has(questionId)) {
//       console.warn("Circular dependency detected:", questionId);
//       return null;
//     }

//     const nextVisited = new Set(visited);
//     nextVisited.add(questionId);

//     const state = stateMap.get(questionId);
//     const children = childrenByParent.get(questionId) || [];

//     const childList = children
//       .map((child) => buildNode(Number(child.questionId), nextVisited))
//       .filter(Boolean) as TreeQuestionItem[];

//     /**
//      * contentIdList روی این نود (والد) قرار می‌گیرد: اجتماع مقادیر محرکی
//      * که خودِ فرزندانش ثبت کرده‌اند (چون آن مقادیر گزینه‌های همین سوال
//      * را نشان می‌دهند). اگر فرزندی وجود نداشته باشد، null است.
//      */
//     const contentIdList =
//       children.length > 0
//         ? Array.from(
//             new Set(children.flatMap((child) => resolveTriggerIds(child)))
//           )
//         : null;

//     return {
//       questionId,
//       contentIdList,
//       priority: priorityMap.get(questionId) ?? 0,
//       isMandatory: Boolean(state?.isRequired ?? false),
//       childList,
//     };
//   };

//   /**
//    * ریشه‌ها: فقط سوالاتی که کاربر واقعاً انتخاب کرده و فرزند هیچ سوال
//    * انتخاب‌شده‌ی دیگری نیستند. ترتیب مستقیماً از formSelectedQuestions گرفته
//    * می‌شود تا با priority هماهنگ بماند.
//    */
//   const rootQuestionIds = formSelectedQuestions
//     .map((item) => Number(item.questionId))
//     .filter((questionId) => !childQuestionIds.has(questionId));

//   return rootQuestionIds
//     .map((questionId) => buildNode(questionId))
//     .filter(Boolean) as TreeQuestionItem[];
// }

// export function generateQuestionInEditMode(questionInstanceList: any[]) {
//   if (!Array.isArray(questionInstanceList) || questionInstanceList.length === 0) {
//     return [];
//   }

//   const resultMap = new Map<
//     number,
//     {
//       questionId: number;
//       parentQuestionId: number;
//       contentId: number[];
//       isRequired: boolean;
//       selectedPoint?: number;
//       _order: number;
//     }
//   >();

//   questionInstanceList.forEach((question: any, index: number) => {
//     const questionId =
//       Number(question.selectQuestion?.id) ||
//       Number(question.questionId) ||
//       0;

//     if (!questionId) return;

//     let parentQuestionId = 0;

//     if (question.selectMainQuestion?.selectQuestion?.id) {
//       parentQuestionId = Number(question.selectMainQuestion.selectQuestion.id);
//     } else if (question.selectMainQuestion?.id) {
//       const parentInstanceId = Number(question.selectMainQuestion.id);

//       const parentInstance = questionInstanceList.find(
//         (item: any) => Number(item.id) === parentInstanceId
//       );

//       parentQuestionId =
//         Number(parentInstance?.selectQuestion?.id) ||
//         Number(parentInstance?.questionId) ||
//         0;
//     } else if (question.parentQuestionId) {
//       parentQuestionId = Number(question.parentQuestionId);
//     }

//     let relatedContentIds: number[] = [];

//     if (question.selectRelatedContent?.id) {
//       relatedContentIds = [Number(question.selectRelatedContent.id)];
//     } else if (Array.isArray(question.contentId)) {
//       relatedContentIds = question.contentId.map(Number).filter(Boolean);
//     } else if (question.contentId) {
//       relatedContentIds = [Number(question.contentId)];
//     } else if (Array.isArray(question.contentIdList)) {
//       relatedContentIds = question.contentIdList.map(Number).filter(Boolean);
//     }

//     const orderKey =
//       typeof question.priority === "number" ? question.priority : index;

//     if (!resultMap.has(questionId)) {
//       resultMap.set(questionId, {
//         questionId,
//         parentQuestionId,
//         contentId: [],
//         isRequired: Boolean(question.isRequired ?? question.isRequierd ?? false),
//         selectedPoint: 0,
//         _order: orderKey,
//       });
//     }

//     const current = resultMap.get(questionId)!;

//     if (!current.parentQuestionId && parentQuestionId) {
//       current.parentQuestionId = parentQuestionId;
//     }

//     relatedContentIds.forEach((id) => {
//       if (id && !current.contentId.includes(id)) {
//         current.contentId.push(id);
//       }
//     });

//     current.isRequired =
//       current.isRequired ||
//       Boolean(question.isRequired ?? question.isRequierd ?? false);
//   });

//   return Array.from(resultMap.values())
//     .sort((a, b) => a._order - b._order)
//     .map(({ _order, ...rest }) => rest);
// }


type FormQuestionDependency = {
  questionId: number;
  parentQuestionId: number;
  contentId: number[];
  isRequired?: boolean;
  /**
   * فقط زمانی مقدار دارد که سوال والد از نوع «درجه‌بندی» (ستاره‌ای) باشد:
   * حداقل تعداد ستاره‌ای که باید انتخاب شود تا این سوال (فرزند) نمایش داده شود.
   */
  selectedPoint?: number;
};

/**
 * نکته‌ی مهم درباره‌ی contentIdList:
 * این فیلد روی خودِ سوال (به‌عنوان والد) قرار می‌گیرد و نشان می‌دهد
 * کدام گزینه‌های پاسخ خودِ همین سوال باعث نمایش فرزندش/فرزندانش می‌شود.
 *
 * - اگر سوال هیچ فرزندی نداشته باشد (برگ درخت): contentIdList = null
 * - اگر فرزند داشته باشد: contentIdList = اجتماع مقادیر محرک (contentId یا
 *   selectedPoint) که روی خودِ فرزندان ثبت شده‌اند
 */
type TreeQuestionItem = {
  questionId: number;
  contentIdList: number[] | null;
  priority: number;
  isMandatory?: boolean;
  childList: TreeQuestionItem[];
};

export function generateQuestionLists(
  selectQuestionList: FormQuestionDependency[],
  questions: any[]
): TreeQuestionItem[] {
  const formSelectedQuestions = selectQuestionList || [];

  const priorityMap = new Map<number, number>();

  formSelectedQuestions.forEach((item, index) => {
    priorityMap.set(Number(item.questionId), index + 1);
  });

  const stateMap = new Map<number, FormQuestionDependency>();

  formSelectedQuestions.forEach((item) => {
    stateMap.set(Number(item.questionId), {
      questionId: Number(item.questionId),
      parentQuestionId: Number(item.parentQuestionId ?? 0),
      contentId: Array.isArray(item.contentId)
        ? item.contentId.map(Number).filter(Boolean)
        : [],
      isRequired: Boolean(item.isRequired),
      selectedPoint:
        typeof item.selectedPoint === "number" ? item.selectedPoint : 0,
    });
  });

  const childrenByParent = new Map<number, FormQuestionDependency[]>();

  formSelectedQuestions.forEach((item) => {
    const parentId = Number(item.parentQuestionId ?? 0);

    if (parentId) {
      const state = stateMap.get(Number(item.questionId))!;

      if (!childrenByParent.has(parentId)) {
        childrenByParent.set(parentId, []);
      }

      childrenByParent.get(parentId)!.push(state);
    }
  });

  const childQuestionIds = new Set<number>();

  formSelectedQuestions.forEach((item) => {
    if (Number(item.parentQuestionId)) {
      childQuestionIds.add(Number(item.questionId));
    }
  });

  const resolveTriggerIds = (child: FormQuestionDependency): number[] => {
    if (typeof child.selectedPoint === "number" && child.selectedPoint > 0) {
      return [child.selectedPoint];
    }

    return Array.isArray(child.contentId) ? child.contentId : [];
  };

  const buildNode = (
    questionId: number,
    visited: Set<number> = new Set()
  ): TreeQuestionItem | null => {
    questionId = Number(questionId);

    if (visited.has(questionId)) {
      console.warn("Circular dependency detected:", questionId);
      return null;
    }

    const nextVisited = new Set(visited);
    nextVisited.add(questionId);

    const state = stateMap.get(questionId);
    const children = childrenByParent.get(questionId) || [];

    const childList = children
      .map((child) => buildNode(Number(child.questionId), nextVisited))
      .filter(Boolean) as TreeQuestionItem[];

    const contentIdList =
      children.length > 0
        ? Array.from(
            new Set(children.flatMap((child) => resolveTriggerIds(child)))
          )
        : null;

    return {
      questionId,
      contentIdList,
      priority: priorityMap.get(questionId) ?? 0,
      isMandatory: Boolean(state?.isRequired ?? false),
      childList,
    };
  };

  const rootQuestionIds = formSelectedQuestions
    .map((item) => Number(item.questionId))
    .filter((questionId) => !childQuestionIds.has(questionId));

  return rootQuestionIds
    .map((questionId) => buildNode(questionId))
    .filter(Boolean) as TreeQuestionItem[];
}


export function generateQuestionInEditMode(
  questionInstanceList: any[]
): FormQuestionDependency[] {
  if (!Array.isArray(questionInstanceList) || questionInstanceList.length === 0) {
    return [];
  }

  const byInstanceId = new Map<number, any>();

  const flatten = (items: any[]) => {
    (items || []).forEach((item: any) => {
      if (item?.id == null) return;
      if (!byInstanceId.has(Number(item.id))) {
        byInstanceId.set(Number(item.id), item);
      }
      if (Array.isArray(item.selectQuestionChild)) {
        flatten(item.selectQuestionChild);
      }
    });
  };
  flatten(questionInstanceList);

  // محرکِ خودِ یک instance
  const extractOwnContentIds = (inst: any): number[] => {
    if (!inst) return [];
    if (inst.selectRelatedContent?.id != null) {
      return [Number(inst.selectRelatedContent.id)];
    }
    if (Array.isArray(inst.questionContentResponseList)) {
      return inst.questionContentResponseList
        .filter((c: any) => c?.id != null)
        .map((c: any) => Number(c.id));
    }
    return [];
  };

  const resultMap = new Map<number, FormQuestionDependency>();

  byInstanceId.forEach((inst) => {
    const questionId = Number(inst.selectQuestion?.id) || Number(inst.questionId) || 0;
    if (!questionId || resultMap.has(questionId)) return;

    // والدِ مستقیم
    let parentQuestionId = 0;
    let parentInst: any = null;
    const parentInstId = inst.selectMainQuestion?.id;
    if (parentInstId != null) {
      parentInst = byInstanceId.get(Number(parentInstId));
      parentQuestionId =
        Number(parentInst?.selectQuestion?.id) || Number(parentInst?.questionId) || 0;
    }

    resultMap.set(questionId, {
      questionId,
      parentQuestionId,
      // ⬇️ کلید اصلاح: محرکِ والد را اینجا (روی فرزند) می‌گذاریم
      contentId: extractOwnContentIds(parentInst),
      priority: Number(inst.priority) || 0,
      isRequired: Boolean(inst.isRequired ?? inst.isRequierd ?? false),
      selectedPoint: 0,
    });
  });

  return Array.from(resultMap.values());
}
